import { UserType } from '../../../../../types/UserType';
import { Text } from '../../../../cdl/Text/Text';
import { HeaderWithLine } from '../../../../common/HeaderWithLine/HeaderWithLine';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { ApiKeyDescription } from '../../../components/ApiKeyDescription';
import { ApiKeysTable } from '../../../components/ApiKeysTable';
import { CreateApiKeyButton } from '../../../components/CreateApiKeyButton';

import { CreateWebhookButton } from './CreateWebhookButton';
import { WebhookDescription } from './WebhookDescription';
import { WebhookTable } from './WebhookTable';

interface CustomerDevelopersTabProps {
    groupId: string;
}

export const CustomerDevelopersTab = ({ groupId }: CustomerDevelopersTabProps) => {
    return (
        <Box display="flex" flexDirection="column" gap={48}>
            <Box display="flex" flexDirection="column" gap={16}>
                <HeaderWithLine description={<ApiKeyDescription />}>
                    <Text variant="subtitle1" as="h2">
                        {translate('apikey.title')}
                    </Text>

                    <CreateApiKeyButton groupId={groupId} userType={UserType.CUSTOMER} />
                </HeaderWithLine>
                <ApiKeysTable groupId={groupId} userType={UserType.CUSTOMER} />
            </Box>

            <Box display="flex" flexDirection="column" gap={16}>
                <HeaderWithLine description={<WebhookDescription />}>
                    <Text variant="subtitle1" as="h2">
                        {translate('webhooks.title')}
                    </Text>

                    <CreateWebhookButton groupId={groupId} />
                </HeaderWithLine>
                <WebhookTable groupId={groupId} />
            </Box>
        </Box>
    );
};
